export default __webpack_public_path__ + "static/media/content-deco-1.5a4df6fb.webp";